import { SignUpHeader } from '../../components/SignUpHeader';
import { ProForgotPasswordForm } from '../../components/ProForgotPasswordForm';
import { AuthTabs } from '../../components/AuthTabs';

export default function ProForgotPasswordPage() {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <SignUpHeader mode="signup" isProfessional={true} showSwitchButton={false} />

      <main className="flex-1 flex flex-col items-center justify-center py-6 md:py-12 px-4 w-full">
        <AuthTabs mode="forgot" active="professional" />
        <ProForgotPasswordForm />
      </main>
    </div>
  );
}
